import { api } from './api';

export interface ForgotPasswordPayload {
  email: string;
}

export interface ResetPasswordPayload {
  token: string;
  password: string;
}

export interface AuthMeResponse {
  success: boolean;
  user: {
    id: number;
    name: string;
    email: string;
    role: 'user' | 'admin' | 'super_admin';
    subscription_plan: 'trial' | 'free' | 'basic' | 'premium';
    subscription_status: 'active' | 'expired' | 'paused';
    subscription_period: 'trial' | 'monthly' | 'yearly' | null;
    subscription_expires_at: string | null;
  };
}

export const requestPasswordReset = (payload: ForgotPasswordPayload) =>
  api.post('/auth/forgot-password', payload);

export const resetPasswordWithToken = (payload: ResetPasswordPayload) =>
  api.post('/auth/reset-password', payload);

export const fetchCurrentUser = () =>
  api.get<AuthMeResponse>('/auth/me');



